/**
 * Generated by orval v8.14.0 🍺
 * Do not edit manually.
 * Remotex.Api, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */
import type {
  ApiEnvelopeCropFarmerCreatedResponse,
  ApiEnvelopeCropFarmerEmptyResponse,
  ApiEnvelopeCropFarmerRunResponse,
  ApiEnvelopeCropFieldListResponse,
  CropFarmerStopCropFarmerParams,
  CropFieldInputDto,
  CropHarvestConfigInputDto,
  CropPlantConfigInputDto,
  RunCropFarmerRequest
} from './schemas';

import { useSfetchMutator } from '../sfetchMutator';


export type cropFarmerGetCropFieldsResponse200 = {
  data: ApiEnvelopeCropFieldListResponse
  status: 200
}

export type cropFarmerGetCropFieldsResponseSuccess = (cropFarmerGetCropFieldsResponse200) & {
  headers: Headers;
};
;

export type cropFarmerGetCropFieldsResponse = (cropFarmerGetCropFieldsResponseSuccess)

export const getCropFarmerGetCropFieldsUrl = () => {




  return `/api/cropfarmer/fields`
}

export const useCropFarmerGetCropFieldsHook = (): ( options?: RequestInit) => Promise<cropFarmerGetCropFieldsResponse> => {

      const customFetcher = useSfetchMutator();
      return ( options?: RequestInit) => {

        return customFetcher(getCropFarmerGetCropFieldsUrl(),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type cropFarmerCreateCropFieldResponse200 = {
  data: ApiEnvelopeCropFarmerCreatedResponse
  status: 200
}

export type cropFarmerCreateCropFieldResponseSuccess = (cropFarmerCreateCropFieldResponse200) & {
  headers: Headers;
};
;

export type cropFarmerCreateCropFieldResponse = (cropFarmerCreateCropFieldResponseSuccess)

export const getCropFarmerCreateCropFieldUrl = () => {




  return `/api/cropfarmer/fields`
}

export const useCropFarmerCreateCropFieldHook = (): (cropFieldInputDto?: CropFieldInputDto, options?: RequestInit) => Promise<cropFarmerCreateCropFieldResponse> => {

      const customFetcher = useSfetchMutator();
      return (cropFieldInputDto?: CropFieldInputDto, options?: RequestInit) => {

        return customFetcher(getCropFarmerCreateCropFieldUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(cropFieldInputDto)
  }
);
      }
  }


export type cropFarmerUpdateCropFieldResponse200 = {
  data: ApiEnvelopeCropFarmerEmptyResponse
  status: 200
}

export type cropFarmerUpdateCropFieldResponse404 = {
  data: ApiEnvelopeCropFarmerEmptyResponse
  status: 404
}

export type cropFarmerUpdateCropFieldResponseSuccess = (cropFarmerUpdateCropFieldResponse200) & {
  headers: Headers;
};
export type cropFarmerUpdateCropFieldResponseError = (cropFarmerUpdateCropFieldResponse404) & {
  headers: Headers;
};

export type cropFarmerUpdateCropFieldResponse = (cropFarmerUpdateCropFieldResponseSuccess | cropFarmerUpdateCropFieldResponseError)

export const getCropFarmerUpdateCropFieldUrl = (id: string,) => {




  return `/api/cropfarmer/fields/${id}`
}

export const useCropFarmerUpdateCropFieldHook = (): (id: string,
    cropFieldInputDto?: CropFieldInputDto, options?: RequestInit) => Promise<cropFarmerUpdateCropFieldResponse> => {

      const customFetcher = useSfetchMutator();
      return (id: string,
    cropFieldInputDto?: CropFieldInputDto, options?: RequestInit) => {

        return customFetcher(getCropFarmerUpdateCropFieldUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(cropFieldInputDto)
  }
);
      }
  }


export type cropFarmerDeleteCropFieldResponse200 = {
  data: ApiEnvelopeCropFarmerEmptyResponse
  status: 200
}

export type cropFarmerDeleteCropFieldResponse404 = {
  data: ApiEnvelopeCropFarmerEmptyResponse
  status: 404
}

export type cropFarmerDeleteCropFieldResponseSuccess = (cropFarmerDeleteCropFieldResponse200) & {
  headers: Headers;
};
export type cropFarmerDeleteCropFieldResponseError = (cropFarmerDeleteCropFieldResponse404) & {
  headers: Headers;
};

export type cropFarmerDeleteCropFieldResponse = (cropFarmerDeleteCropFieldResponseSuccess | cropFarmerDeleteCropFieldResponseError)

export const getCropFarmerDeleteCropFieldUrl = (id: string,) => {




  return `/api/cropfarmer/fields/${id}`
}

export const useCropFarmerDeleteCropFieldHook = (): (id: string, options?: RequestInit) => Promise<cropFarmerDeleteCropFieldResponse> => {

      const customFetcher = useSfetchMutator();
      return (id: string, options?: RequestInit) => {

        return customFetcher(getCropFarmerDeleteCropFieldUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);
      }
  }


export type cropFarmerScanCropFieldResponse200 = {
  data: ApiEnvelopeCropFarmerRunResponse
  status: 200
}

export type cropFarmerScanCropFieldResponse400 = {
  data: ApiEnvelopeCropFarmerRunResponse
  status: 400
}

export type cropFarmerScanCropFieldResponse404 = {
  data: ApiEnvelopeCropFarmerRunResponse
  status: 404
}

export type cropFarmerScanCropFieldResponseSuccess = (cropFarmerScanCropFieldResponse200) & {
  headers: Headers;
};
export type cropFarmerScanCropFieldResponseError = (cropFarmerScanCropFieldResponse400 | cropFarmerScanCropFieldResponse404) & {
  headers: Headers;
};

export type cropFarmerScanCropFieldResponse = (cropFarmerScanCropFieldResponseSuccess | cropFarmerScanCropFieldResponseError)

export const getCropFarmerScanCropFieldUrl = (id: string,) => {




  return `/api/cropfarmer/fields/${id}/scan`
}

export const useCropFarmerScanCropFieldHook = (): (id: string,
    runCropFarmerRequest?: RunCropFarmerRequest, options?: RequestInit) => Promise<cropFarmerScanCropFieldResponse> => {

      const customFetcher = useSfetchMutator();
      return (id: string,
    runCropFarmerRequest?: RunCropFarmerRequest, options?: RequestInit) => {

        return customFetcher(getCropFarmerScanCropFieldUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(runCropFarmerRequest)
  }
);
      }
  }


export type cropFarmerCreateCropHarvestConfigResponse200 = {
  data: ApiEnvelopeCropFarmerCreatedResponse
  status: 200
}

export type cropFarmerCreateCropHarvestConfigResponse404 = {
  data: ApiEnvelopeCropFarmerCreatedResponse
  status: 404
}

export type cropFarmerCreateCropHarvestConfigResponseSuccess = (cropFarmerCreateCropHarvestConfigResponse200) & {
  headers: Headers;
};
export type cropFarmerCreateCropHarvestConfigResponseError = (cropFarmerCreateCropHarvestConfigResponse404) & {
  headers: Headers;
};

export type cropFarmerCreateCropHarvestConfigResponse = (cropFarmerCreateCropHarvestConfigResponseSuccess | cropFarmerCreateCropHarvestConfigResponseError)

export const getCropFarmerCreateCropHarvestConfigUrl = () => {




  return `/api/cropfarmer/harvest`
}

export const useCropFarmerCreateCropHarvestConfigHook = (): (cropHarvestConfigInputDto?: CropHarvestConfigInputDto, options?: RequestInit) => Promise<cropFarmerCreateCropHarvestConfigResponse> => {

      const customFetcher = useSfetchMutator();
      return (cropHarvestConfigInputDto?: CropHarvestConfigInputDto, options?: RequestInit) => {

        return customFetcher(getCropFarmerCreateCropHarvestConfigUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(cropHarvestConfigInputDto)
  }
);
      }
  }


export type cropFarmerUpdateCropHarvestConfigResponse200 = {
  data: ApiEnvelopeCropFarmerEmptyResponse
  status: 200
}

export type cropFarmerUpdateCropHarvestConfigResponse404 = {
  data: ApiEnvelopeCropFarmerEmptyResponse
  status: 404
}

export type cropFarmerUpdateCropHarvestConfigResponseSuccess = (cropFarmerUpdateCropHarvestConfigResponse200) & {
  headers: Headers;
};
export type cropFarmerUpdateCropHarvestConfigResponseError = (cropFarmerUpdateCropHarvestConfigResponse404) & {
  headers: Headers;
};

export type cropFarmerUpdateCropHarvestConfigResponse = (cropFarmerUpdateCropHarvestConfigResponseSuccess | cropFarmerUpdateCropHarvestConfigResponseError)

export const getCropFarmerUpdateCropHarvestConfigUrl = (id: string,) => {




  return `/api/cropfarmer/harvest/${id}`
}

export const useCropFarmerUpdateCropHarvestConfigHook = (): (id: string,
    cropHarvestConfigInputDto?: CropHarvestConfigInputDto, options?: RequestInit) => Promise<cropFarmerUpdateCropHarvestConfigResponse> => {

      const customFetcher = useSfetchMutator();
      return (id: string,
    cropHarvestConfigInputDto?: CropHarvestConfigInputDto, options?: RequestInit) => {

        return customFetcher(getCropFarmerUpdateCropHarvestConfigUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(cropHarvestConfigInputDto)
  }
);
      }
  }


export type cropFarmerDeleteCropHarvestConfigResponse200 = {
  data: ApiEnvelopeCropFarmerEmptyResponse
  status: 200
}

export type cropFarmerDeleteCropHarvestConfigResponse404 = {
  data: ApiEnvelopeCropFarmerEmptyResponse
  status: 404
}

export type cropFarmerDeleteCropHarvestConfigResponseSuccess = (cropFarmerDeleteCropHarvestConfigResponse200) & {
  headers: Headers;
};
export type cropFarmerDeleteCropHarvestConfigResponseError = (cropFarmerDeleteCropHarvestConfigResponse404) & {
  headers: Headers;
};

export type cropFarmerDeleteCropHarvestConfigResponse = (cropFarmerDeleteCropHarvestConfigResponseSuccess | cropFarmerDeleteCropHarvestConfigResponseError)

export const getCropFarmerDeleteCropHarvestConfigUrl = (id: string,) => {




  return `/api/cropfarmer/harvest/${id}`
}

export const useCropFarmerDeleteCropHarvestConfigHook = (): (id: string, options?: RequestInit) => Promise<cropFarmerDeleteCropHarvestConfigResponse> => {

      const customFetcher = useSfetchMutator();
      return (id: string, options?: RequestInit) => {

        return customFetcher(getCropFarmerDeleteCropHarvestConfigUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);
      }
  }


export type cropFarmerRunCropHarvestConfigResponse200 = {
  data: ApiEnvelopeCropFarmerRunResponse
  status: 200
}

export type cropFarmerRunCropHarvestConfigResponse400 = {
  data: ApiEnvelopeCropFarmerRunResponse
  status: 400
}

export type cropFarmerRunCropHarvestConfigResponse404 = {
  data: ApiEnvelopeCropFarmerRunResponse
  status: 404
}

export type cropFarmerRunCropHarvestConfigResponseSuccess = (cropFarmerRunCropHarvestConfigResponse200) & {
  headers: Headers;
};
export type cropFarmerRunCropHarvestConfigResponseError = (cropFarmerRunCropHarvestConfigResponse400 | cropFarmerRunCropHarvestConfigResponse404) & {
  headers: Headers;
};

export type cropFarmerRunCropHarvestConfigResponse = (cropFarmerRunCropHarvestConfigResponseSuccess | cropFarmerRunCropHarvestConfigResponseError)

export const getCropFarmerRunCropHarvestConfigUrl = (id: string,) => {




  return `/api/cropfarmer/harvest/${id}/run`
}

export const useCropFarmerRunCropHarvestConfigHook = (): (id: string,
    runCropFarmerRequest?: RunCropFarmerRequest, options?: RequestInit) => Promise<cropFarmerRunCropHarvestConfigResponse> => {

      const customFetcher = useSfetchMutator();
      return (id: string,
    runCropFarmerRequest?: RunCropFarmerRequest, options?: RequestInit) => {

        return customFetcher(getCropFarmerRunCropHarvestConfigUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(runCropFarmerRequest)
  }
);
      }
  }


export type cropFarmerCreateCropPlantConfigResponse200 = {
  data: ApiEnvelopeCropFarmerCreatedResponse
  status: 200
}

export type cropFarmerCreateCropPlantConfigResponse400 = {
  data: ApiEnvelopeCropFarmerCreatedResponse
  status: 400
}

export type cropFarmerCreateCropPlantConfigResponse404 = {
  data: ApiEnvelopeCropFarmerCreatedResponse
  status: 404
}

export type cropFarmerCreateCropPlantConfigResponseSuccess = (cropFarmerCreateCropPlantConfigResponse200) & {
  headers: Headers;
};
export type cropFarmerCreateCropPlantConfigResponseError = (cropFarmerCreateCropPlantConfigResponse400 | cropFarmerCreateCropPlantConfigResponse404) & {
  headers: Headers;
};

export type cropFarmerCreateCropPlantConfigResponse = (cropFarmerCreateCropPlantConfigResponseSuccess | cropFarmerCreateCropPlantConfigResponseError)

export const getCropFarmerCreateCropPlantConfigUrl = () => {




  return `/api/cropfarmer/plant`
}

export const useCropFarmerCreateCropPlantConfigHook = (): (cropPlantConfigInputDto?: CropPlantConfigInputDto, options?: RequestInit) => Promise<cropFarmerCreateCropPlantConfigResponse> => {

      const customFetcher = useSfetchMutator();
      return (cropPlantConfigInputDto?: CropPlantConfigInputDto, options?: RequestInit) => {

        return customFetcher(getCropFarmerCreateCropPlantConfigUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(cropPlantConfigInputDto)
  }
);
      }
  }


export type cropFarmerUpdateCropPlantConfigResponse200 = {
  data: ApiEnvelopeCropFarmerEmptyResponse
  status: 200
}

export type cropFarmerUpdateCropPlantConfigResponse400 = {
  data: ApiEnvelopeCropFarmerEmptyResponse
  status: 400
}

export type cropFarmerUpdateCropPlantConfigResponse404 = {
  data: ApiEnvelopeCropFarmerEmptyResponse
  status: 404
}

export type cropFarmerUpdateCropPlantConfigResponseSuccess = (cropFarmerUpdateCropPlantConfigResponse200) & {
  headers: Headers;
};
export type cropFarmerUpdateCropPlantConfigResponseError = (cropFarmerUpdateCropPlantConfigResponse400 | cropFarmerUpdateCropPlantConfigResponse404) & {
  headers: Headers;
};

export type cropFarmerUpdateCropPlantConfigResponse = (cropFarmerUpdateCropPlantConfigResponseSuccess | cropFarmerUpdateCropPlantConfigResponseError)

export const getCropFarmerUpdateCropPlantConfigUrl = (id: string,) => {




  return `/api/cropfarmer/plant/${id}`
}

export const useCropFarmerUpdateCropPlantConfigHook = (): (id: string,
    cropPlantConfigInputDto?: CropPlantConfigInputDto, options?: RequestInit) => Promise<cropFarmerUpdateCropPlantConfigResponse> => {

      const customFetcher = useSfetchMutator();
      return (id: string,
    cropPlantConfigInputDto?: CropPlantConfigInputDto, options?: RequestInit) => {

        return customFetcher(getCropFarmerUpdateCropPlantConfigUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(cropPlantConfigInputDto)
  }
);
      }
  }


export type cropFarmerDeleteCropPlantConfigResponse200 = {
  data: ApiEnvelopeCropFarmerEmptyResponse
  status: 200
}

export type cropFarmerDeleteCropPlantConfigResponse404 = {
  data: ApiEnvelopeCropFarmerEmptyResponse
  status: 404
}

export type cropFarmerDeleteCropPlantConfigResponseSuccess = (cropFarmerDeleteCropPlantConfigResponse200) & {
  headers: Headers;
};
export type cropFarmerDeleteCropPlantConfigResponseError = (cropFarmerDeleteCropPlantConfigResponse404) & {
  headers: Headers;
};

export type cropFarmerDeleteCropPlantConfigResponse = (cropFarmerDeleteCropPlantConfigResponseSuccess | cropFarmerDeleteCropPlantConfigResponseError)

export const getCropFarmerDeleteCropPlantConfigUrl = (id: string,) => {




  return `/api/cropfarmer/plant/${id}`
}

export const useCropFarmerDeleteCropPlantConfigHook = (): (id: string, options?: RequestInit) => Promise<cropFarmerDeleteCropPlantConfigResponse> => {

      const customFetcher = useSfetchMutator();
      return (id: string, options?: RequestInit) => {

        return customFetcher(getCropFarmerDeleteCropPlantConfigUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);
      }
  }


export type cropFarmerRunCropPlantConfigResponse200 = {
  data: ApiEnvelopeCropFarmerRunResponse
  status: 200
}

export type cropFarmerRunCropPlantConfigResponse400 = {
  data: ApiEnvelopeCropFarmerRunResponse
  status: 400
}

export type cropFarmerRunCropPlantConfigResponse404 = {
  data: ApiEnvelopeCropFarmerRunResponse
  status: 404
}

export type cropFarmerRunCropPlantConfigResponseSuccess = (cropFarmerRunCropPlantConfigResponse200) & {
  headers: Headers;
};
export type cropFarmerRunCropPlantConfigResponseError = (cropFarmerRunCropPlantConfigResponse400 | cropFarmerRunCropPlantConfigResponse404) & {
  headers: Headers;
};

export type cropFarmerRunCropPlantConfigResponse = (cropFarmerRunCropPlantConfigResponseSuccess | cropFarmerRunCropPlantConfigResponseError)

export const getCropFarmerRunCropPlantConfigUrl = (id: string,) => {




  return `/api/cropfarmer/plant/${id}/run`
}

export const useCropFarmerRunCropPlantConfigHook = (): (id: string,
    runCropFarmerRequest?: RunCropFarmerRequest, options?: RequestInit) => Promise<cropFarmerRunCropPlantConfigResponse> => {

      const customFetcher = useSfetchMutator();
      return (id: string,
    runCropFarmerRequest?: RunCropFarmerRequest, options?: RequestInit) => {

        return customFetcher(getCropFarmerRunCropPlantConfigUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(runCropFarmerRequest)
  }
);
      }
  }


export type cropFarmerStopCropFarmerResponse200 = {
  data: ApiEnvelopeCropFarmerEmptyResponse
  status: 200
}

export type cropFarmerStopCropFarmerResponse404 = {
  data: ApiEnvelopeCropFarmerEmptyResponse
  status: 404
}

export type cropFarmerStopCropFarmerResponseSuccess = (cropFarmerStopCropFarmerResponse200) & {
  headers: Headers;
};
export type cropFarmerStopCropFarmerResponseError = (cropFarmerStopCropFarmerResponse404) & {
  headers: Headers;
};

export type cropFarmerStopCropFarmerResponse = (cropFarmerStopCropFarmerResponseSuccess | cropFarmerStopCropFarmerResponseError)

export const getCropFarmerStopCropFarmerUrl = (params?: CropFarmerStopCropFarmerParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/cropfarmer/stop?${stringifiedParams}` : `/api/cropfarmer/stop`
}

export const useCropFarmerStopCropFarmerHook = (): (params?: CropFarmerStopCropFarmerParams, options?: RequestInit) => Promise<cropFarmerStopCropFarmerResponse> => {

      const customFetcher = useSfetchMutator();
      return (params?: CropFarmerStopCropFarmerParams, options?: RequestInit) => {

        return customFetcher(getCropFarmerStopCropFarmerUrl(params),
  {
    ...options,
    method: 'DELETE'


  }
);
      }
  }


